module.exports = __webpack_public_path__ + "static/media/stella.17a100cc.png";